import { render, staticRenderFns } from "./LivesByCompany.vue?vue&type=template&id=50e4ff9f&"
import script from "./LivesByCompany.vue?vue&type=script&lang=js&"
export * from "./LivesByCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports